"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRAYER_HUBS_UPDATE_PARTICIPATION_COUNTER = exports.PRAYER_HUBS_DELETE = exports.PRAYER_HUBS_UPDATE = exports.PRAYER_HUBS_GET_ONE = exports.PRAYER_HUBS_AUTO_FILL = exports.PRAYER_HUBS_UPDATE_PINNED_ORDER = exports.PRAYER_HUBS = exports.PRAYERS_DELETE = exports.PRAYERS_UPDATE = exports.PRAYERS = exports.ENCOURAGEMENT_MESSAGES_DELETE = exports.ENCOURAGEMENT_MESSAGES_UPDATE = exports.ENCOURAGEMENT_MESSAGES = exports.PSALMS_CHAPTERS_DELETE = exports.PSALMS_CHAPTERS_UPDATE = exports.PSALMS_CHAPTERS = exports.CATEGORY_DELETE = exports.CATEGORY_UPDATE = exports.CATEGORY = exports.DELETE_CAMPAIGN = exports.GET_CAMPAIGN = exports.PAGINATE_CAMPAIGNS = exports.CREATE_CAMPAIGN = exports.CONFIRM_CLIENT_UPLOAD = exports.GET_ASSET_CLIENT_UPLOAD_URL = exports.CONFIRM_UPLOAD = exports.GET_ASSET_RESUMABLE_UPLOAD_URL = exports.GET_ASSET_UPLOAD_URL = exports.SETTINGS_GET = exports.STATS = exports.USERS_DELETE = exports.USERS_UPDATE = exports.USERS_UPDATE_STATS = exports.USERS = exports.AUTH_USER_ME = exports.AUTH_USER = exports.PAGINATE_FORMS = exports.DELETE_FORM = exports.UPDATE_FORM = exports.GET_FORM = exports.CREATE_FORM = exports.ADMINS_PAGINATE = exports.ADMINS_DELETE = exports.ADMINS_UPDATE = exports.ADMINS_CREATE = exports.AUTH_SESSION_OUT = exports.AUTH_SESSION_IN = exports.AUTH_ADMIN_ME = exports.AUTH_ADMIN = exports.ROOT = void 0;
exports.PRAYER_HUBS_GET_ONE_PUBLIC = exports.PRAYER_HUBS_PUBLIC_CREATE = exports.PRAYER_HUBS_PUBLIC = void 0;
exports.ROOT = "/api";
// Admin:
exports.AUTH_ADMIN = "".concat(exports.ROOT, "/auth/admin");
exports.AUTH_ADMIN_ME = "".concat(exports.ROOT, "/auth/admin/me");
exports.AUTH_SESSION_IN = "".concat(exports.ROOT, "/auth/session-in");
exports.AUTH_SESSION_OUT = "".concat(exports.ROOT, "/auth/session-out");
exports.ADMINS_CREATE = "".concat(exports.ROOT, "/admins/create");
exports.ADMINS_UPDATE = "".concat(exports.ROOT, "/admins/update/:id");
exports.ADMINS_DELETE = "".concat(exports.ROOT, "/admins/delete/:id");
exports.ADMINS_PAGINATE = "".concat(exports.ROOT, "/admins/paginate");
// Forms:
exports.CREATE_FORM = "".concat(exports.ROOT, "/forms/create");
exports.GET_FORM = "".concat(exports.ROOT, "/forms/get/:id");
exports.UPDATE_FORM = "".concat(exports.ROOT, "/forms/update/:id");
exports.DELETE_FORM = "".concat(exports.ROOT, "/forms/delete/:id");
exports.PAGINATE_FORMS = "".concat(exports.ROOT, "/forms/paginate");
// Client routes:
exports.AUTH_USER = "".concat(exports.ROOT, "/auth/user");
exports.AUTH_USER_ME = "".concat(exports.ROOT, "/auth/user/me");
exports.USERS = "".concat(exports.ROOT, "/users");
exports.USERS_UPDATE_STATS = "".concat(exports.USERS, "/:id/statistics");
exports.USERS_UPDATE = "".concat(exports.USERS, "/:id");
exports.USERS_DELETE = "".concat(exports.USERS, "/:id");
exports.STATS = "".concat(exports.ROOT, "/statistics");
exports.SETTINGS_GET = "".concat(exports.ROOT, "/settings/get");
// Asset
exports.GET_ASSET_UPLOAD_URL = "".concat(exports.ROOT, "/asset/upload-url");
exports.GET_ASSET_RESUMABLE_UPLOAD_URL = "".concat(exports.ROOT, "/asset/get-resumable-upload-url");
exports.CONFIRM_UPLOAD = "".concat(exports.ROOT, "/asset/confirm-upload");
exports.GET_ASSET_CLIENT_UPLOAD_URL = "".concat(exports.ROOT, "/asset/website/upload-url");
exports.CONFIRM_CLIENT_UPLOAD = "".concat(exports.ROOT, "/asset/website/confirm-upload");
// Admin: prayers campaigns
exports.CREATE_CAMPAIGN = "".concat(exports.ROOT, "/campaign/create");
exports.PAGINATE_CAMPAIGNS = "".concat(exports.ROOT, "/campaign/paginate");
exports.GET_CAMPAIGN = "".concat(exports.ROOT, "/campaign/get/:id");
exports.DELETE_CAMPAIGN = "".concat(exports.ROOT, "/campaign/delete/:id");
// categories
exports.CATEGORY = "".concat(exports.ROOT, "/category");
exports.CATEGORY_UPDATE = "".concat(exports.CATEGORY, "/:id");
exports.CATEGORY_DELETE = "".concat(exports.CATEGORY, "/:id");
// psalms_chapters
exports.PSALMS_CHAPTERS = "".concat(exports.ROOT, "/psalms_chapters");
exports.PSALMS_CHAPTERS_UPDATE = "".concat(exports.PSALMS_CHAPTERS, "/:id");
exports.PSALMS_CHAPTERS_DELETE = "".concat(exports.PSALMS_CHAPTERS, "/:id");
// encouragement_messages
exports.ENCOURAGEMENT_MESSAGES = "".concat(exports.ROOT, "/encouragement_messages");
exports.ENCOURAGEMENT_MESSAGES_UPDATE = "".concat(exports.ENCOURAGEMENT_MESSAGES, "/:id");
exports.ENCOURAGEMENT_MESSAGES_DELETE = "".concat(exports.ENCOURAGEMENT_MESSAGES, "/:id");
// prayers
exports.PRAYERS = "".concat(exports.ROOT, "/prayers");
exports.PRAYERS_UPDATE = "".concat(exports.PRAYERS, "/:id");
exports.PRAYERS_DELETE = "".concat(exports.PRAYERS, "/:id");
// prayer_hubs
exports.PRAYER_HUBS = "".concat(exports.ROOT, "/prayer_hubs");
exports.PRAYER_HUBS_UPDATE_PINNED_ORDER = "".concat(exports.ROOT, "/pinned/order");
exports.PRAYER_HUBS_AUTO_FILL = "".concat(exports.PRAYER_HUBS, "/auto-fill");
exports.PRAYER_HUBS_GET_ONE = "".concat(exports.PRAYER_HUBS, "/:id");
exports.PRAYER_HUBS_UPDATE = "".concat(exports.PRAYER_HUBS, "/:id");
exports.PRAYER_HUBS_DELETE = "".concat(exports.PRAYER_HUBS, "/:id");
exports.PRAYER_HUBS_UPDATE_PARTICIPATION_COUNTER = "".concat(exports.PRAYER_HUBS, "/:id/participation-counter");
exports.PRAYER_HUBS_PUBLIC = "".concat(exports.ROOT, "/prayer_hubs/public");
exports.PRAYER_HUBS_PUBLIC_CREATE = "".concat(exports.PRAYER_HUBS_PUBLIC, "/create");
exports.PRAYER_HUBS_GET_ONE_PUBLIC = "".concat(exports.PRAYER_HUBS_PUBLIC, "/:id");
//# sourceMappingURL=routes.js.map